<template>
  <BtnToggle 
    :title="$t('engine.manageText.modalWidget.tooltip.lblLink', languageEngine)"
    @click="openModalLink"
  >
    <i class="far fa-link fs-16"></i>
  </BtnToggle>
</template>

<script>
import { mapGetters } from "vuex";
import BtnToggle from "./_BtnToggle";

export default {
  components: {
    BtnToggle,
  },
  data() {
    return {
      formatLinkClear: {
        linkType: false,
        linkTarget: false,
        link: false,
        linkPageID: false,
        linkSectionID: false,
        linkFileID: false,
        linkFileName: false,
        linkPhoneCode: false,

        linkTypeOld: false,
        linkPageIdOld: false,
        linkSectionIdOld: false,
        linkDocNameOld: false,
        phoneCodeOld: false,

        underline: false,
        decoration: false,
      }
    }
  },
  computed: {
    ...mapGetters({
      languageUse: "designIframe/metadata/siteActiveLanguage",
      languageEngine: "designIframe/userPreference/languageEngine",
      texteditor: "designIframe/texteditor/texteditor",
      siteComponents: "designIframe/metadata/siteComponents",
    }),
    selectionFormatMerge() {
      return this.texteditor.selectionFormatMerge;
    },
    value() {
      return this.convertFormatToLinkValue(this.selectionFormatMerge);
    },
  },
  methods: {
    convertFormatToLinkValue(value) {
      const type = (value.linkType || value.linkTypeOld) || 
        (value.link && value.link.includes('http') && 'url') || 
        (value.link && value.link.includes('https') && 'url') || 
        (value.link && value.link.includes('mailto') && 'email') || 
        (value.link && value.link.includes('tel') && 'phone') ||
        (value.link && 'url') ||
        undefined;
      return {
        type: type,
        target: value.linkTarget,
        url: 
          (type == 'url') ? value.link : undefined,
        pageID: 
          (type == 'page') ? value.linkPageID || value.linkPageIdOld : undefined,
        sectionPageID: 
          (type == 'anchor') ? value.linkPageID || value.linkPageIdOld : undefined,
        sectionID: 
          (type == 'page' || type == 'anchor') ? value.linkSectionID : undefined,
        email: 
          (type == 'email') ? value.link.replace('mailto:', '').replace(/\?subject=.*/, '').trim() : undefined,
        emailSubject: 
          (type == 'email') ? decodeURIComponent(value.link.substring(value.link.indexOf('?subject='), value.link.length).replace('?subject=', '').trim()) : undefined,
        phone: 
          (type == 'phone') ? value.link.replace('tel:', '').trim() : undefined,
        phoneCountry: 
          (type == 'phone') ? value.linkPhoneCode || value.phoneCodeOld : undefined,
        phoneFormat: 
          (type == 'phone') ? null : undefined,
        fileID: 
          (type == 'file') ? value.linkFileID : undefined,
        fileName: 
          (type == 'file') ? value.linkFileName : undefined,
        fileUrl: 
          (type == 'file') ? value.link.trim() : undefined,
      }
    },
    convertLinkValueToFormat(value) {
      switch (value.linkType) {
        case 'url': return {
          ...this.formatLinkClear,
          linkType: 'url',
          linkTarget: value.target,
          link: this.$helper.url.genValidUrl(value.url),
          
          underline: false,
          decoration: this.selectionFormatMerge.isIcon ? false : 'underline',
        }
        case 'page': return {
          ...this.formatLinkClear,
          linkType: 'page',
          linkTarget: value.target,
          linkPageID: value.pageID,
          link: value.pageID ? this.genUrlPage(value.pageID, null, this.languageUse) : '',
          
          underline: false,
          decoration: this.selectionFormatMerge.isIcon ? false : 'underline',
        }
        case 'anchor': return {
          ...this.formatLinkClear,
          linkType: 'anchor',
          linkTarget: '_self',
          linkPageID: value.sectionPageID,
          linkSectionID: value.sectionID,
          link: value.sectionPageID ? this.genUrlPage(value.sectionPageID, value.sectionID, this.languageUse) : '',

          underline: false,
          decoration: this.selectionFormatMerge.isIcon ? false : 'underline',
        }
        case 'email': return {
          ...this.formatLinkClear,
          linkType: 'email',
          linkTarget: '_self',
          link: `mailto:${value.email}?subject=${encodeURIComponent(value.emailSubject ? value.emailSubject : "")}`,
          
          underline: false,
          decoration: this.selectionFormatMerge.isIcon ? false : 'underline',
        }
        case 'phone': return {
          ...this.formatLinkClear,
          linkType: 'phone',
          linkTarget: '_self',
          linkPhoneCode: value.phoneCountry,
          link: `tel:${value.phone}`,
          
          underline: false,
          decoration: this.selectionFormatMerge.isIcon ? false : 'underline',
        }
        case 'file': return {
          ...this.formatLinkClear,
          linkType: 'file',
          linkTarget: '_blank',
          linkFileID: value.file.id,
          linkFileName: value.file.name,
          link: value.file.url,
          
          underline: false,
          decoration: this.selectionFormatMerge.isIcon ? false : 'underline',
        }
        default: return this.formatLinkClear;
      }
    },
    genUrlPage(pageID, sectionID = null, language = null) {
      const cmpPage = this.siteComponents[pageID];
      let value = '';
      value += language ? `/${language}` : '';
      value += '';
      value += (cmpPage && cmpPage.properties.url) ? `/${cmpPage.properties.url}` : '/undefined';
      value += sectionID ? `#${sectionID}` : '';
      return value;
    },
    openModalLink() {
      this.$store.dispatch("designIframe/texteditor/setData", { forceFocus: true });
      this.$store.dispatch("designIframe/modals/setModal", {
        modal_id: "modal-add-link-widget-tools",
        payload: this.value,
        callback:{
          save: (value) => {
            this.$store.dispatch("designIframe/texteditor/setData", { forceFocus: false });
            this.onChange(value);
          },
          cancel: () => {
            this.$store.dispatch("designIframe/texteditor/setData", { forceFocus: false });
          },
          close: () => {
            this.$store.dispatch("designIframe/texteditor/setData", { forceFocus: false });
          },
        },
      });
    },
    onChange(value) {
      const selection = this.texteditor.editor.getSelection();
      const formatValues = this.convertLinkValueToFormat(value);

      this.texteditor.editor.formatText(selection, formatValues);
    },
  },
}
</script>
